(function () {
  var SHIMMER_CLASS = "is-shimmering";
  var PRESS_CLASS = "is-pressing";
  var SHIMMER_DURATION_MS = 4000;
  var PRESS_DURATION_MS = 350;

  function getButtonFromEventTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest(".new-btn");
  }

  function startShimmer(button) {
    if (!button || button.classList.contains(SHIMMER_CLASS)) return;

    button.classList.add(SHIMMER_CLASS);

    var shimmerTimeoutId = window.setTimeout(function () {
      button.classList.remove(SHIMMER_CLASS);
    }, SHIMMER_DURATION_MS + 50);

    var handleAnimationEnd = function (event) {
      if (
        event.animationName !== "new-btn-shimmer-after" &&
        event.animationName !== "new-btn-shimmer-before"
      ) {
        return;
      }

      if (event.animationName === "new-btn-shimmer-after") {
        window.clearTimeout(shimmerTimeoutId);
        button.classList.remove(SHIMMER_CLASS);
      }
    };

    button.addEventListener("animationend", handleAnimationEnd, { once: false });
    window.setTimeout(function () {
      button.removeEventListener("animationend", handleAnimationEnd);
    }, SHIMMER_DURATION_MS + 250);
  }

  function startPress(button) {
    if (!button) return;

    button.classList.remove(PRESS_CLASS);
    // Restart the keyframe on repeated clicks.
    void button.offsetWidth;
    button.classList.add(PRESS_CLASS);

    window.setTimeout(function () {
      button.classList.remove(PRESS_CLASS);
    }, PRESS_DURATION_MS);
  }

  document.addEventListener("mouseover", function (event) {
    var button = getButtonFromEventTarget(event.target);
    if (!button) return;
    startShimmer(button);
  });

  document.addEventListener("mousedown", function (event) {
    var button = getButtonFromEventTarget(event.target);
    if (!button) return;
    startPress(button);
  });
})();
